// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avator {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/component/SyllabusComponent/index.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AACJ","sourcesContent":[".avator {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
